<script>
	import pluginsList from 'view/audioTracker/plugins/plugins-list';
	export default {
		translationCategory: 'creative.CreativeContextMenu',
		data() {
			return {
				insertionKinds: [
					{ id: 'media', name: () => this.$tCaption('Media'), icon: 'cloud-arrow-up' },
					{ id: 'textToSpeech', name: () => this.$tCaption('Voice'), icon: 'users-cog' },
					{ id: 'record', name: () => this.$tCaption('Recording'), icon: 'microphone' },
					{ id: 'aiScript', name: () => this.$tCaption('New AI Script'), icon: 'scroll', hidden: (creativeDetail) => creativeDetail?.readonly },
					{ id: 'voiceMessage', name: () => this.$tCaption('Voice message'), icon: 'voicemail', hidden: (creativeDetail) => !creativeDetail?.hasVoiceMessages },
					{
						id: 'break',
						name: () => this.$tCaption('Break'),
						icon: 'grip-lines-vertical',
						hidden: () => !(this.$auth.hasNetworkStudio() || this.opts?.networkStudio)
					},
					{ id: 'audioFile', name: () => this.$tCaption('Audio file'), icon: 'file-audio', hidden: () => true },
					{ id: 'video', name: () => this.$tCaption('Video'), icon: 'video', hidden: () => true },
				],
				aggregatedTrackActionsList: [
					{
						id: 'processing',
						name: () => this.$tCaption('Processing'),
						template: 'header',
						disabled: true
					},
					...pluginsList.plugins.map(p => ({
						id: `wapiPlugin_${p.id}`,
						name: p.name,
						icon: (track) => {
							let plugin = this.getActiveWapiPlugin(track.__aggregatedTrack, p.id);
							return `${p.icon || 'fas fa-microchip'} ${plugin?.enabled ? 'tracker-active-icon' : ''}`
						},
						hidden: (track) => ['video'].includes(track?.__type)
					})),
					{
						id: 'normalize',
						name: () => this.$tCaption('Normalize'),
						icon: (track, aggTrack) => `fas fa-wave-square ${aggTrack?.normalize?.enabled ? 'tracker-active-icon' : ''}`,
						hidden: (track, aggTrack) => aggTrack?.__type === 'video'
					},
					{
						id: 'wapiPluginsManager',
						name: () => this.$tCaption('Effects manager'),
						icon: 'fas fa-gears',
						hidden: (track) => track.__isSubTrack || !track.__isAudioTrack
					},
					{
						id: 'common',
						name: () => this.$tCaption('Common'),
						template: 'header',
						disabled: true
					},
					{
						id: 'geoTarget',
						name: () => this.$tCaption('Set geo target'),
						icon: 'fas fa-map-marker-alt',
						hidden: (track) => !track.__isSubTrack
					},
					{
						id: 'trackCriteria',
						name: () => this.$tCaption('Edit criteria'),
						icon: (track, aggTrack) => `fas fa-filter ${aggTrack?.condition ? 'tracker-active-icon' : ''}`
					},
					{
						id: 'duplicateAggregatedTrack',
						name: () => this.$tCaption('Duplicate track'),
						icon: 'fas fa-clone'
					},
					{
						id: 'fileUploadRequest',
						name: () => this.$tCaption('File upload request'),
						icon: 'fas fa-upload'
					}
				],
			};
		},
		computed: {
			trackActionsGroups() {
				return [
					{
						id: 'tools',
						name: () => this.$tCaption('Tools'),
						icon: () => 'toolbox',
					},
					{
						id: 'subTracksGenerators',
						name: () => this.$tCaption('Sub-tracks'),
						icon: (tracks) => tracks.some(f => f.__isGeneratingSubInsertions) ? 'fas fa-circle-notch fa-spin' : 'fas fas fa-table'
					},
					{
						id: 'linkActions',
						name: () => this.$tCaption('Link'),
						icon: () => 'fas fa-link'
					},
					{
						id: 'unlinkActions',
						name: () => this.$tCaption('Unlink'),
						icon: () => 'fas fa-unlink'
					},
					...(this.isNetworkStudio ? this.networkStudioInsertionContextMenuGroups : []),
				];
			},
			trackActionsList() {
				return [
					{
						id: 'processing',
						name: () => this.$tCaption('Processing'),
						template: 'header',
						disabled: true
					},
					{
						id: 'cut',
						name: () => this.$tCaption('Cut'),
						icon: 'fas fa-cut',
						hidden: (track) => !track.__isAudioEditableTrack
					},
					{
						id: 'trim-silence',
						name: () => this.$tCaption('Trim'),
						icon: 'fas fa-broom',
						hidden: (track) => !track.__isAudioEditableTrack
					},
					{
						id: 'split',
						name: () => this.$tCaption('Split'),
						icon: 'fas fa-grip-lines-vertical',
						hidden: (track) => !track.__isAudioEditableTrack
					},
					{
						id: 'splitSsmlSentences',
						name: () => this.$tCaption('Split sentences'),
						icon: 'fas fa-grip-lines-vertical',
						hidden: (track) => track.type !== 'textToSpeech'
					},
					{
						id: 'normalize',
						name: () => this.$tCaption('Normalize'),
						icon: 'fas fa-wave-square',
						hidden: (track) => !track.__isAudioEditableTrack
					},
					{
						id: 'fadeInOut', name: () => this.$tCaption('Fade In/Out'),
						icon: (track) => `fas fa-slash ${track?.insertion?.JsonConfig?.fadeIn?.value || track?.insertion?.JsonConfig?.fadeOut?.value ? 'tracker-active-icon' : ''}`,
						hidden: (track) => track.__isSubTrack || !track.__isAudioTrack
					},
					{
						id: 'freeze-ssml',
						name: () => this.$tCaption('Freeze'),
						icon: 'fas fa-arrows-to-dot',
						hidden: (track) => track.type !== 'textToSpeech'
					},
					{
						id: 'volumeEnvelope',
						name: () => this.$tCaption('Volume envelope'),
						icon: (track) => `fas fa-vector-square ${track?.insertion?.JsonConfig?.volumeEnvelope?.enabled ? 'tracker-active-icon' : ''}`,
						hidden: (track) => !track.__isAudioTrack,
						group: 'tools'
					},
					{
						id: 'pitchEnvelope',
						name: () => this.$tCaption('Pitch envelope'),
						icon: (track) => `fas fa-up-down ${track?.insertion?.JsonConfig?.pitchEnvelope?.enabled ? 'tracker-active-icon' : ''}`,
						hidden: (track) => !track.__isAudioTrack,
						group: 'tools'
					},
					{
						id: 'exactLength',
						name: () => this.$tCaption('Exact length'),
						icon: () => 'fas fa-arrows-left-right',
						hidden: (track) => !track.__isAudioTrack,
						group: 'tools'
					},
					{
						id: 'audioOverdubbingTool',
						name: () => this.$tCaption('Overdub'),
						icon: () => 'fas fa-indent',
						hidden: (track) => !track.__isAudioEditableTrack,
						group: 'tools'
					},
					{
						id: 'audioConversionTool',
						name: () => this.$tCaption('Conversion'),
						icon: () => 'fas fa-user-gear',
						hidden: (track) => !track.__isAudioEditableTrack,
						group: 'tools'
					},
					{
						id: 'textBasedAudioEditor',
						name: () => this.$tCaption('SonicScribe'),
						icon: () => 'fas fa-list-check',
						hidden: (track) => !track.__isAudioEditableTrack,
						group: 'tools'
					},
					{
						id: 'resetInsertion',
						name: () => this.$tCaption('Reset'),
						icon: () => 'fas fa-ban'
					},
					...(this.isNetworkStudio ? [
						{
							id: 'networkStudio',
							name: () => this.$tCaption('Network studio'),
							template: 'header',
							disabled: true
						},
						...this.networkStudioInsertionContextMenu
					] : []),
					{
						id: 'common',
						name: () => this.$tCaption('Common'),
						template: 'header',
						disabled: true
					},
					{
						id: 'duplicate',
						name: () => this.$tCaption('Duplicate clip'),
						icon: 'fas fa-clone',
						hidden: (track) => !track.__isAudioTrack
					},
					{
						id: 'addSubTrack',
						name: () => this.$tCaption('Add sub track'),
						icon: 'fas fa-plus',
						hidden: (track) => track.__isSubTrack || !track.__isAudioTrack
					},
					{
						id: 'geoTarget',
						name: () => this.$tCaption('Set geo target'),
						icon: 'fas fa-map-marker-alt',
						hidden: (track) => !track.__isSubTrack
					},
					{
						id: 'recordAudio',
						name: () => this.$tCaption('Record audio'),
						hidden: (track) => track.type !== 'audioFile',
						icon: () => 'fas fa-microphone'
					},
					{
						id: 'generateSubInsertions',
						name: () => this.$tCaption('Generate SSML sub-tracks'),
						busy: (track) => track.__isGeneratingSubInsertions,
						hidden: (track) => track.__isSubTrack || track.type !== 'textToSpeech',
						icon: (track) => track.__isGeneratingSubInsertions ? 'fas fa-circle-notch fa-spin' : 'fas fa-wand-sparkles',
						group: 'subTracksGenerators'
					},
					{
						id: 'recordSubInsertions',
						name: () => this.$tCaption('Record sub-tracks'),
						busy: (track) => track.__isGeneratingSubInsertions,
						hidden: (track) => track.__isSubTrack || !track.__isAudioTrack,
						icon: (track) => track.__isGeneratingSubInsertions ? 'fas fa-circle-notch fa-spin' : 'fas fa-microphone',
						group: 'subTracksGenerators'
					},
					{
						id: 'deleteSubTracks',
						name: () => this.$tCaption('Delete sub tracks'),
						icon: 'fas fa-trash',
						hidden: (track) => !track.__totalSubInsertions,
						group: 'subTracksGenerators'
					},
					{
						id: 'link',
						name: () => this.$tCaption('Link position'),
						hidden: (track) => track.__linkedTo?.some(f => f.sourceLinkType === 'both'),
						icon: 'fas fa-link',
						group: 'linkActions'
					},
					{
						id: 'linkStart',
						name: () => this.$tCaption('Link trim start'),
						hidden: (track) => track.__linkedTo?.some(f => f.sourceLinkType === 'start'),
						icon: 'fas fa-arrow-right-from-bracket',
						group: 'linkActions'
					},
					{
						id: 'linkEnd',
						name: () => this.$tCaption('Link trim end'),
						hidden: (track) => track.__linkedTo?.some(f => f.sourceLinkType === 'end'),
						icon: 'fas fa-arrow-right-to-bracket',
						group: 'linkActions'
					},
					{
						id: 'unlink',
						name: () => this.$tCaption('Unlink all'),
						hidden: (track) => !(track.__linkedTo?.some(f => (f.sourceLinkType || 'both') === 'both') || track.__linkedTo.length > 1),
						icon: 'fas fa-unlink',
						group: 'unlinkActions'
					},
					{
						id: 'unlinkStart',
						name: () => this.$tCaption('Unlink start'),
						hidden: (track) => !track.__linkedTo?.some(f => f.sourceLinkType === 'start'),
						icon: 'fas fa-arrow-right-from-bracket',
						group: 'unlinkActions'
					},
					{
						id: 'unlinkEnd',
						name: () => this.$tCaption('Unlink end'),
						hidden: (track) => !track.__linkedTo?.some(f => f.sourceLinkType === 'end'),
						icon: 'fas fa-arrow-right-to-bracket',
						group: 'unlinkActions'
					},
					{
						id: 'edit',
						name: () => this.$tCaption('Edit'),
						icon: 'fas fa-edit',
						hidden: (track) => !track.__isAudioTrack
					},
					{
						id: 'translationQA',
						name: () => this.$tCaption('Translation QA'),
						icon: 'fas fa-language',
						hidden: (track) => !(track?.type === 'textToSpeech' && track?.insertion?.OriginalAudio)
					},
					{ id: 'delete', name: () => this.$tCaption('Delete'), icon: 'fas fa-trash' },
				];
			}
		},
		watch: {
			
		},
		mounted() {
			
		},
		destroyed() {
			
		},
		methods: {
			prepareContextMenuActions(actions) {
				const result = [];
				const processedGroups = {};
				actions.map(action => {
					if (action.group) {
						if (!processedGroups[action.group]) {
							const actionGroup = this.trackActionsGroups.find(f => f.id === action.group);
							const items = actions.filter(f => f.group === action.group);
							result.push({
								items,
								text: actionGroup.name(),
								icon: actionGroup.icon(items),
								isGroup: true
							});
						}
						processedGroups[action.group] = true;
					} else {
						result.push(action);
					}
				});
				return result;
			}
		},
	};
</script>